var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "career") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quiz-Node",
    transform: "translate(-122.000000, -820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "career",
    transform: "translate(122.000000, 820.000000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C6.80965,0 6.25,0.559652798 6.25,1.25000625 L6.25,9.99905 C5.7381875,10.1795509 5.2577125,10.4745524 4.84835,10.8838044 L0.7322375,14.99995 C0.2633875,15.4688273 0,16.1047055 0,16.7678338 L0,22.4999875 C0,23.8807444 1.1192875,25 2.5,25 L22.5,25 C23.88075,25 25,23.8807444 25,22.4999875 L25,19.2678463 C25,18.604718 24.736625,17.9688398 24.26775,17.4999625 L21.401625,14.6339482 C19.937125,13.1694408 17.562875,13.1694408 16.098375,14.6339482 L15,15.7322037 L10.151625,10.8838044 C9.7422875,10.4745524 9.2618125,10.1795509 8.75,9.99905 L8.75,7.5000375 L15,7.5000375 C15.43325,7.5000375 15.8355,7.27572388 16.063375,6.90719704 C16.291125,6.53867019 16.31175,6.07849289 16.118,5.69101596 L15.1475,3.75001875 L16.118,1.80902155 C16.31175,1.42154461 16.291125,0.961367307 16.063375,0.592840464 C15.8355,0.224313622 15.43325,0 15,0 L7.5,0 Z M12.9775,5.000025 L8.75,5.000025 L8.75,2.5000125 L12.9775,2.5000125 L12.632,3.19100346 C12.456,3.54290521 12.456,3.95713229 12.632,4.30903405 L12.9775,5.000025 Z M2.5,16.7678338 L6.6161125,12.6516883 C7.104275,12.1634358 7.895725,12.1634358 8.3838875,12.6516883 L14.116125,18.3838419 C14.60425,18.8720944 15.39575,18.8720944 15.883875,18.3838419 L17.866125,16.401707 C18.35425,15.9134546 19.14575,15.9134546 19.633875,16.401707 L22.5,19.2678463 L22.5,22.4999875 L2.5,22.4999875 L2.5,16.7678338 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.e348feabf05002e1e6238a7f88a195ef.svg";
export { ForwardRef as ReactComponent };